import React from 'react';
import { IPhraseNotesPreviewProps } from './types';
import { theme } from '../../../../../../common/styles/theme';
import { Box, Button, Stack } from '@mui/material';
import { PhraseNoteHTML } from '../../PhraseNoteHTML/components/PhraseNoteHTML';
import { CLASS_SPEAKER_SCROLL } from '../../../../../../common/constants';

export const PhraseNotesPreview: React.FC<IPhraseNotesPreviewProps> = ({
	text,
	authorName,
	authorUserName,
	onEdit,
	onClickAuthor,
}) => {

	const [_note, setNote] = React.useState<string>('');
	React.useEffect(() => {
		let _note = '';
		if (text) {
			let br = '<br>';
			if (!text.includes('</')) { // input without html (translates -> save to note)
				_note = text.trim().replaceAll(/\n/gm, br);
			} else { // html
				_note = text.trim().replaceAll(/<p><\/p>/gm, br);
			}
		}
		setNote(_note);
	}, [text]);

	if (!_note) return null;

	return (
		<Stack
			className={`${CLASS_SPEAKER_SCROLL}`}
			alignItems={'flex-start'}
			sx={{
				position: 'relative',
				flex: `1 1 100%`,
				minHeight: 0,
				overflow: 'auto',
			}}
		>
			<PhraseNoteHTML
				text={_note}
				isSpeaker
			/>

			<Stack
				flexDirection={'row'}
				alignItems={'center'}
				gap={2}
				sx={{
					position: 'sticky',
					bottom: 0,
					width: 1,
					p: theme.spacing(1, 0),
					background: theme.palette.common.white,
				}}
			>
				<Button
					onClick={onEdit}
					variant={'contained'}
					sx={{
						
					}}
				>
					Edit note
				</Button>

				{!!authorUserName &&
					<Box
						sx={{
							fontSize: theme.typography.subtitle2,
							fontWeight: 300,
							overflow: 'hidden',
						}}
					>
						Created by
						{' '}
						<Button
							variant={'text'}
							onClick={onClickAuthor}
							sx={{
								textDecoration: 'underline',
							}}
						>
							{authorName}
						</Button>
					</Box>
				}
			</Stack>

		</Stack>
	);

}
